import { TextMenu } from "./menu";
import { toggleFullScreen } from "../utilities/toggle-fullscreen";
import { GameState } from "../state/game-state";

/**
 * Online gameplay menu that only shows "Toggle Full Screen"
 */
export function getOnlineGameplayMenu(
  container: HTMLElement,
  _gameState: GameState,
): TextMenu {
  return new TextMenu(container, "Menu", [
    {
      display: "Toggle Full Screen",
      action: () => {
        toggleFullScreen();
      },
    },
  ]);
}
